<template>
  <v-flex xs12 px-3 py-3>
    <v-card class="adder-card srp-card">
      <v-layout row align-center px-3 class="card-title">
        <v-flex grow fill-height justify-center>
          <v-checkbox
            :label="component.title"
            v-model="chosen"
            @change="toggleComponent"
          ></v-checkbox>
        </v-flex>
      </v-layout>
      <v-layout row pa-3>
        <v-flex xs12>
          <v-img class="card-preview" contain width="100%" :src="imagePreview(component)"></v-img>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "SRPComponentPreview",
  props: ['componentType', "component"],
  data() {
    return {
      chosen: false
    }
  },
  computed: {
    ...mapState(['chosenBrand']),
    ...mapGetters(
      ['imagePreview', 'chosenArray']
    )
  },
  mounted() {
    this.setChosen();
  },
  methods: {
    setChosen() {
      if (this.containsObject(this.component, this.chosenArray)) {
        this.chosen = true;
      } else {
        this.chosen = false;
      }
    },
    toggleComponent() {
      if (this.containsObject(this.component, this.chosenArray)) {
        for (var i = 0; i < this.$store.state.chosenComponents.length; i++) {
          if (this.$store.state.chosenComponents[i] === this.component) {
            this.$store.state.chosenComponents.splice(i,1);
          }
        }
      }
      else {
        this.$store.state.chosenComponents.push(this.component);
      }
    },
    containsObject(obj, list) {
      var i;
      for (i = 0; i < list.length; i++) {
          if (list[i] === obj) {
              return true;
          }
      }
      return false;
    }
  },
  watch: {
    chosenArray: function() {
      this.setChosen();
    }
  }
};
</script>

<style scoped>
.adder-card {
  padding: 0;
  border-radius: 9px;
  box-shadow: 0px 3px 10px 4px rgb(0 106 255 / 8%),
    0px 2px 2px 0px rgb(0 83 199 / 9%), 0px 1px 5px 0px rgb(0 83 199 / 9%);
}
.card-preview {
  height: 300px;
}
</style>

<style>
.adder-card .v-input--selection-controls .v-input__control,
.adder-card .v-input--selection-controls .v-icon,
.adder-card {
  color: #006aff;
}
.adder-card .v-input--selection-controls.v-input .v-label {
  color: #000;
}
.adder-card.srp-card .v-input--selection-controls {
  margin-top: 8px;
}
.adder-card.srp-card .card-title .v-input__slot {
  margin-bottom: 0;
}
.adder-card .v-image {
  border-radius: 0px;
}
</style>